
import React, { useState, useEffect } from 'react';
import CustomButton from '../../../component/elements/CustomButton/CustomButton';
import CloseIcon from '@mui/icons-material/Close';
import StarIcon from '@mui/icons-material/Star';

function CustomerView({ onClose,dialogDetails }) {


    return (
        <div className="pt-6 px-4" >
            <div className="flex justify-end mb-2">
                <button
                    className=" text-gray-600 hover:text-black"
                    onClick={onClose}
                    aria-label="Close"
                >
                    <CloseIcon />
                </button>
            </div>
            <div className='flex flex-col w-full justify-center items-center' >
                <div>
                    <div className='flex mb-2 gap-2'>
                        <div className='font-[500] text-[#222222] '>Customer Name: </div>
                        <div className='text-[#565656]'>{dialogDetails?.name}</div>
                    </div>
                    <div className='flex mb-2 gap-2'>
                        <div className='font-[500] text-[#222222] '>Past Orders: </div>
                        <div className='text-[#565656]'>{dialogDetails?.totalOrders || 0} Orders Completed</div>
                    </div>
                    {/* <div className='flex mb-2 gap-2'>
                        <div className='font-[500] text-[#222222]'>Reviews: </div>
                        <div className='text-[#565656]'>
                            {[...Array(5)].map((_, i) => (
                                <StarIcon
                                    key={i}
                                    fontSize="small"
                                    sx={{ color: i < 3 ? '#facc15' : '#e5e7eb' }}
                                />
                            ))}
                            (3 average)</div>
                    </div> */}
                    <div className='flex mb-2 gap-2'>
                        <div className='font-[500] text-[#222222] '>Customer Tag: </div>
                        <div className='text-[#565656]'>{dialogDetails?.order_status}</div>
                    </div>
                    <div className='flex mb-2 gap-2'>
                        <div className='font-[500] text-[#222222]'>Loyalty Status:</div>
                        <div className='text-[#565656]'>{dialogDetails?.loyalty || 'N/A'}</div>
                    </div>

                </div>
                <div className="flex justify-center items-center mt-8 mb-4">
                    <CustomButton
                        onClick={() => onClose()}
                        customeClass={`gradient-button w-full sm:w-[150px] h-[40px]`}
                    >
                        Ok
                    </CustomButton>
                </div>
            </div>
        </div>
    );
}

export default CustomerView;